module.exports = __webpack_public_path__ + "img/b_07.b430a5de.png";